import { jsx as _jsx } from "react/jsx-runtime";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { Divider } from "@material-ui/core";
export const SeparatorField = () => {
    return _jsx(Divider, { style: { width: "100%" } });
};
SeparatorField.displayName = "SeparatorField";
export const EditorSeparator = identityRecordOfFieldEditorOptions({
    SeparatorField: {
        editableOptions: {}
    }
});
//# sourceMappingURL=SeparatorField.js.map